import * as React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import { centered_flex_box } from "../../app/components/Styles";
import { useParams } from "react-router-dom";
import { downloadInvitationTicket } from "../../app/store/actions/commonActions";
import { MarketingPage, MarketingCard } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const DownloadTicket = ({ isLoading, isError, downloadInvitationTicket }) => {
  const { id } = useParams();

  React.useEffect(() => {
    downloadInvitationTicket({ ticketId: id });
  }, []);

  if (isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ ...centered_flex_box, flexDirection: "column", py: 8, gap: 2 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
          <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray600 }}>
            Fetching ticket...
          </Typography>
        </Box>
      </MarketingPage>
    );
  }

  return (
    <MarketingPage maxWidth="sm">
      {isError ? (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center" }}>
            Something went wrong
          </Typography>
        </MarketingCard>
      ) : (
        <MarketingCard>
          <Typography sx={{ ...sectionTitleSx, fontSize: "1.5rem", textAlign: "center", mb: 1 }}>
            Ticket downloaded!
          </Typography>
          <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.p700, textAlign: "center", fontSize: "1.25rem" }}>
            See you there
          </Typography>
        </MarketingCard>
      )}
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.wait?.isLoading,
  isError: state?.wait?.isError,
});

const mapDispatchToProps = { downloadInvitationTicket };

export default connect(mapStateToProps, mapDispatchToProps)(DownloadTicket);
